export const GET_PROFILE= "GET_PROFILE"
export const UPDATE_PROFILE= "UPDATE_PROFILE"
export const INITIAL_STATES = "INITIAL_STATES"
export const GET_USER_TYPE = "GET_USER_TYPE"
export const UPDATE_USER_IN_ORG = "UPDATE_USER_IN_ORG"
export const ADD_USER_IN_ORG = "ADD_USER_IN_ORG"
export const RESET_PASSWORD = "RESET_PASSWORD"